import React from "react";
import { RoleReducer } from "./RoleReducer";

const initialValue = {
    loading: true,
    loadingEntities: true,
    loadingAttributes: true,
    loadingPages: true,
    loadingOtherRights: true,
    data: [],
    entities: [],
    attributes: [],
    pages: [],
    listData: {},
    chartsData: {},
    selectedRole: {},
    selectedEntity: {},
    selectedAttribute: {},
    selectedPage: {},
    inProgressItems: [],
    savedItems: [],
    entityInProgressItems: [],
    entitySavedItems: [],
    attributeInProgressItems: [],
    attributeSavedItems: [],
    pageInProgressItems: [],
    pageSavedItems: [],
    otherRightsInProgressItems:[],
    otherRightsSavedItems:[],
    selectedEntityRightsTab: 0,
    showCreateRoleDialog: false,
    showDeleteRoleDialog: false,
    processingRole: false,
    toUpdateRole: {},
    toDeleteRole: {},
    nameError: { isValid: true, message: "" },
    panes: [
        { size: "50%", min: "15%", collapsible: false },
        { min: "50%", collapsible: false }
    ]
}

export const RoleContext = React.createContext(initialValue)

export const RoleContextProvider = ({ children, value = {} }) => {

    const [state, dispatch] = React.useReducer(RoleReducer, { ...initialValue, ...value })

    return (
        <RoleContext.Provider value={{
            state,
            dispatch
        }}>
            {children}
        </RoleContext.Provider>
    )
}